import { apiClient } from "./client";

export interface MethodMeta {
  key: string;
  label_i18n: string;
  available: boolean;
}

export interface HourComparison {
  hour: number;
  fact: number | string | null;
  forecasts: Record<string, number | string | null>;
}

export interface MethodSummary {
  method_key: string;
  n_hours: number;
  mean_signed_error_pct: number | string | null;
  mean_abs_error_pct: number | string | null;
  mean_abs_error_uah: number | string | null;
}

export interface RdnComparison {
  date: string;
  methods: MethodMeta[];
  hours: HourComparison[];
  day_summary: MethodSummary[];
}

export interface RdnAccuracy {
  from_date: string;
  to_date: string;
  methods: MethodMeta[];
  summary: MethodSummary[];
}

export const rdnForecastsApi = {
  comparison: (date: string) =>
    apiClient
      .get<RdnComparison>("/rdn-forecasts/comparison", { params: { date } })
      .then((r) => r.data),

  accuracy: (from: string, to: string) =>
    apiClient
      .get<RdnAccuracy>("/rdn-forecasts/accuracy", { params: { from, to } })
      .then((r) => r.data),
};
